import { useContext, useMemo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ListItem } from 'foundations-components/transitional/components/List';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { getImportWizardUrl } from '../../routing/utils/externalUrls';
import { NEW_USER_ONBOARDING_TOUR_NAME } from '../../tour/config/NewUserOnboardingTourConfig';
import UsageTracker, { beforeUnloadTracker } from '../../utils/UsageTracker';
import { useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const useMoreKnowledgeBaseActions = ({
  toggleExportDialog
}) => {
  const {
    tour
  } = useContext(TourContext);
  const canWriteArticle = useAppSelector(state => state.knowledgeScopes.canWriteArticle);
  const actions = useMemo(() => {
    return [/*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        disabled: canWriteArticle,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.export.permissionTooltip"
        }),
        children: /*#__PURE__*/_jsx(Button, {
          disabled: !canWriteArticle,
          onClick: () => {
            toggleExportDialog();
            UsageTracker.track('manageArticleInteraction', {
              screen: 'manage-articles',
              action: 'export-articles'
            });
          },
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "knowledgeContentUI.export.exportButtonLabel"
          })
        })
      })
    }, "export-articles-permission-tooltip"), /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        disabled: canWriteArticle,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.toolsDropdown.importPermissionTooltip"
        }),
        children: /*#__PURE__*/_jsx(Button, {
          disabled: !canWriteArticle,
          onClick: () => {
            beforeUnloadTracker.track('manageArticleInteraction', {
              screen: 'manage-articles',
              action: 'import-articles'
            });
          },
          href: getImportWizardUrl(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.toolsDropdown.import"
          })
        })
      })
    }, "import-articles-permission-tooltip"), /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: () => {
          tour.start(NEW_USER_ONBOARDING_TOUR_NAME);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.toolsDropdown.startTour"
        })
      })
    }, "start-onboarding-tour")];
  }, [canWriteArticle, toggleExportDialog, tour]);
  return actions;
};
export default useMoreKnowledgeBaseActions;